(function () {
  if (customElements.get('ugc-slider')) return;

  class UgcSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.ugc-section__slides');
      if (!this.slider) return;

      this.cleanupBreakpoint = window.SliderSettings.onBreakpointChange(() => {
        this.destroySlider();
        this.createSlider();
      });

      if (typeof Flickity !== 'undefined') {
        this.createSlider();
      } else {
        /* CFSN-622: Flickity wird global in layout/theme.liquid NACH content_for_layout (deferred) geladen,
           läuft also nach diesem (ebenfalls deferred) Script — aber garantiert VOR DOMContentLoaded. Deshalb
           dort initialisieren statt bei window.load; sonst bliebe der Track auf video-lastigen Seiten bis zum
           vollständigen Laden nur ein overflow-geklippter Flex-Row mit unerreichbaren Offscreen-Cards.
           Bei nachträglicher Injektion (Theme-Editor) ist Flickity bereits da → Zweig oben. */
        const initWhenReady = () => {
          if (typeof Flickity !== 'undefined') this.createSlider();
        };
        if (document.readyState === 'loading' || document.readyState === 'interactive') {
          document.addEventListener('DOMContentLoaded', initWhenReady, { once: true });
        } else {
          window.addEventListener('load', initWhenReady, { once: true });
        }
      }
    }

    createSlider() {
      if (typeof Flickity === 'undefined') return;
      // Keep "no arrows on mobile" (swipe-only) — arrows appear from tablet up.
      // The global slider_show_arrows still suppresses them on desktop when off.
      const isMobile = window.SliderSettings.isMobile();
      const opts = window.getFlickityOptions(this, null, {
        prevNextButtons: !isMobile && window.getSliderSettings(this).showArrows,
      });
      this.flkty = new Flickity(this.slider, opts);

      if (typeof window.datoraUpdatePrices === 'function') {
        window.datoraUpdatePrices(this);
      }
    }

    destroySlider() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    disconnectedCallback() {
      this.cleanupBreakpoint?.();
      this.destroySlider();
    }
  }

  customElements.define('ugc-slider', UgcSlider);
})();
